export default "__VITE_ASSET__51279bb7__"